import React from "react";
import LeftAbout from "../images/about_left.png";
import { ReactComponent as Rarr } from "../images/rarr.svg";

export default function About() {
  return (
    <section className="container _about" id="about">
      <div className="about_wrapper">
        <div className="row">
          <div className="col-md-6">
            <div className="left_about">
              <img
                src={LeftAbout}
                className="aboutLeftimage"
                alt="left_about"
              />
            </div>
          </div>
          <div className="col-md-6 _right">
            <div className="right_about">
              <div className="about_content">
                <h1 className="about_heading d-flex align-items-center">
                  <span className="divider"></span> &nbsp; About Me
                </h1>
                <div className="content1">
                  Hello, Guys My Self Yash Purohit I'm Currently Pursuing Bachelor's Degree In Information Technology And I Have Completed Diploma In Computer Engineering.
                </div>
                <div className="content2">
                  Iam a Front-End Developer. I Love To Design, Create Websites &
                  Webapps. Iam Currently Learning MERN Stack Development.
                </div>
                <div className="content3">
                  Other Than Developing Websites And Apps I Love To Create
                  Gaming Thumbnails In Photoshop And To Create Web & App UI
                  Designs using Figma & Adobe XD.
                </div>
                <div className="content4">
                  I Have Created Many Projects With Simple Designs.
                </div>
                <div className="btn_resume">
                  <a
                    href="https://drive.google.com/file/d/1rgOoROdOOSxcKMfv5ICpcFPncAgyN7dx/view?usp=sharing"
                    className="btn resume_btn"
                  >
                    Download Resume <Rarr />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
